import { gql, GraphQLClient } from "graphql-request";

export const getProjects = async () => {
  const graphQLClient = new GraphQLClient(
    "https://api-eu-west-2.graphcms.com/v2/cl56jurut3zna01umhpqlaws6/master"
  );
  const query = gql`
    query MyQuery {
      projects {
        excerpt
        liveLink
        repo
        slug
        title
        image {
          url
        }
      }
    }
  `;

  const result = await graphQLClient.request(query);
  return result.projects;
};

export const getProjectDetails = async (slug) => {
  const graphQLClient = new GraphQLClient(
    "https://api-eu-west-2.graphcms.com/v2/cl56jurut3zna01umhpqlaws6/master"
  );
  const query = gql`
    query GetProjectDetails($slug: String!) {
      project(where: { slug: $slug }) {
        content {
          raw
        }
        image {
          url
        }
        liveLink
        repo
        title
      }
    }
  `;

  const result = await graphQLClient.request(query, { slug });
  return result.project;
};

export const getIntro = async () => {
  const graphQLClient = new GraphQLClient(
    "https://api-eu-west-2.graphcms.com/v2/cl56jurut3zna01umhpqlaws6/master"
  );
  const query = gql`
    query MyQuery {
      description {
        intro
        resume {
          url
        }
      }
    }
  `;

  const result = await graphQLClient.request(query);
  return result.description;
};

export const getAbout = async () => {
  const graphQLClient = new GraphQLClient(
    "https://api-eu-west-2.graphcms.com/v2/cl56jurut3zna01umhpqlaws6/master"
  );
  const query = gql`
    query MyQuery {
      description {
        about {
          raw
        }
      }
    }
  `;

  const result = await graphQLClient.request(query);
  return result.description;
};
